import React from 'react';
import './AnnualReport.css';

export default function Annual() {
  return (
    <div className='annual-main-container'>
      <div className="A-heading">
        <h1>Annual Report</h1>
      </div>

      <div className="A-large-container">
        <div className="A-small-cards">
          <img className='sevapathimage' src="images/SEWA PATH.png" alt="Annual Report 2022-23" />
          <div className="A-pass-heading">
            <p>Annual Report 2022-23</p>
          </div>
        </div>

        <div className="A-small-cards">
          <img className='sevapathimage' src="images/SEWA PATH.png" alt="Annual Report 2022-23" />
          <div className="A-pass-heading">
            <p>Annual Report 2022-23</p>
          </div>
        </div>

        <div className="A-small-cards">
          <img className='sevapathimage' src="images/SEWA PATH.png" alt="Annual Report 2022-23" />
          <div className="A-pass-heading">
            <p>Annual Report 2022-23</p>
          </div>
        </div>

        <div className="A-small-cards">
          <img className='sevapathimage' src="images/SEWA PATH.png" alt="Annual Report 2022-23" />
          <div className="A-pass-heading">
            <p>Annual Report 2022-23</p>
          </div>
        </div>

        <div className="A-small-cards">
          <img className='sevapathimage' src="images/SEWA PATH.png" alt="Annual Report 2022-23" />
          <div className="A-pass-heading">
            <p>Annual Report 2022-23</p>
          </div>
        </div>

        <div className="A-small-cards">
          <img className='sevapathimage' src="images/SEWA PATH.png" alt="Annual Report 2022-23" />
          <div className="A-pass-heading">
            <p>Annual Report 2022-23</p>
          </div>
        </div>
      </div>
    </div>
  );
}